export default "__VITE_ASSET__SPSYa11g__"